import { SPECIAL_CONDITIONS } from '@/pages/panel-interno/planning-page/model/constants/special-conditions'
import { Badge } from '@/shared/ui/badge'
import { Card } from '@/shared/ui/card'

export const SpecialConditionsLegend = () => (
    <Card className='p-2'>
        <div className='grid grid-cols-7 gap-2'>
            {SPECIAL_CONDITIONS.map(condition => (
                <Badge key={condition.symbol} variant='outline' className='cursor-default text-sm'>
                    <span className='mr-1'>{condition.symbol}</span>
                    {condition.label}
                </Badge>
            ))}
        </div>
    </Card>
)
